<div class="modal-backdrop" (click)="onCancel()">
  <div class="modal-card" (click)="$event.stopPropagation()">
    <h3 class="modal-title">{{ title }}</h3>
    <p class="modal-message">{{ message }}</p>
    <p class="modal-error" *ngIf="errorMessage">{{ errorMessage }}</p>
    <div class="modal-actions">
      <button class="btn-cancel" [disabled]="loading" (click)="onCancel()">{{ cancelText }}</button>
      <button class="btn-confirm" [disabled]="loading" (click)="onConfirm()">
        <span *ngIf="!loading">{{ confirmText }}</span>
        <span *ngIf="loading" class="btn-spinner"></span>
      </button>
    </div>
  </div>
</div>
